import React, { useRef, useState } from 'react';
import styles from './DropZone.module.css';

export default function DropZone({ onLoad }) {
  const inputRef = useRef(null);
  const [dragging, setDragging] = useState(false);
  const [error, setError] = useState('');

  const processFile = (file) => {
    if (!file) return;
    setError('');
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = JSON.parse(e.target.result);
        if (!data.log || !data.log.entries) throw new Error('No HAR entries found');
        onLoad(data, file.name);
      } catch (err) {
        setError('Invalid or malformed HAR/JSON file. Please check and try again.');
      }
    };
    reader.readAsText(file);
  };

  const onDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    processFile(e.dataTransfer.files[0]);
  };

  const onFileChange = (e) => processFile(e.target.files[0]);

  return (
    <div className={styles.wrap}>
      <div
        className={`${styles.zone} ${dragging ? styles.dragging : ''}`}
        onClick={() => inputRef.current.click()}
        onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
        onDragLeave={() => setDragging(false)}
        onDrop={onDrop}
      >
        <div className={styles.glow} />
        <div className={styles.icon}>📡</div>
        <div className={styles.title}>Drop your HAR file here</div>
        <div className={styles.sub}>
          or <span className={styles.link}>browse files</span> &nbsp;·&nbsp; supports <code>.har</code> and <code>.json</code>
        </div>
        <div className={styles.privacy}>
          🔒 <strong>100% private</strong> — files are parsed locally in your browser and never uploaded to any server
        </div>
        {error && <div className={styles.error}>{error}</div>}
      </div>
      <input ref={inputRef} type="file" accept=".har,.json" onChange={onFileChange} style={{ display: 'none' }} />

      <div className={styles.features}>
        <div className={styles.feat}><span>🎯</span> In-scope filtering</div>
        <div className={styles.feat}><span>🔍</span> Search headers & params</div>
        <div className={styles.feat}><span>📋</span> One-click URL copy</div>
        <div className={styles.feat}><span>⬇</span> Export filtered URLs</div>
        <div className={styles.feat}><span>🔒</span> Zero server uploads</div>
        <div className={styles.feat}><span>⚡</span> Instant parsing</div>
      </div>
    </div>
  );
}
